const INFO_LINKS = 'Informace a odkazy';
const LOCATIONS_HEADING = 'Lokality';
const DIVISION_HEADING = 'Členění';
const SEARCH_HEADING = 'Hledání';
const ADMINISTRATIVE_DIVISION_HEADING = 'Administrativní členění';
const DIALECTAL_DIVISION_HEADING = 'Nářeční členění';
const HISTORICAL_DIVISION_HEADING = 'Historické členění';
const BACKGROUND_HEADING = 'Podklad';
const DOWNLOADING_DATA_MSG = 'Stahuji data...';
const COLOR_SELECTION = 'Výběr barvy';
const DIALECT_SELECTION = 'Výběr nářečí';
const LAYERS_SELECTION = 'Rozbalit výběr vrstev';
const DOWNLOAD_MAP = 'Stáhnout mapu';
const COPY_ATTRIBUTION = 'Zkopíruj citaci';
const TEXT_COPIED = 'Text úspěšně zkopírován.';
const TEXT_NOT_COPIED = 'Text nebyl zkopírován.';
const DEFAULT = 'Výchozí';
const OK = 'OK';
const CANCEL = 'Zrušit';
const LOAD = 'Načíst';
const SAVE = 'Uložit';
const EXPORT = 'Export';
const ZOOM_IN = 'Přiblížit';
const ZOOM_OUT = 'Oddálit';

export {
    INFO_LINKS,
    LOCATIONS_HEADING,
    DIVISION_HEADING,
    SEARCH_HEADING,
    ADMINISTRATIVE_DIVISION_HEADING,
    DIALECTAL_DIVISION_HEADING,
    HISTORICAL_DIVISION_HEADING,
    BACKGROUND_HEADING,
    DOWNLOADING_DATA_MSG,
    COLOR_SELECTION,
    DIALECT_SELECTION,
    LAYERS_SELECTION,
    DOWNLOAD_MAP,
    COPY_ATTRIBUTION,
    TEXT_COPIED,
    TEXT_NOT_COPIED,
    DEFAULT,
    OK,
    CANCEL,
    LOAD,
    SAVE,
    EXPORT,
    ZOOM_IN,
    ZOOM_OUT,
};
